import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { event } from '../../../elements/funciones/estructuras';

@Injectable({
  providedIn: 'root'
})
export class AnalisisCombinadoService {
  private apiUrl = environment.apiOperativoDev;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookies: CookieService,
    private https: HttpClient, 
  ) {  }

  public getEventos(){
    const apiURL = this.apiUrl+'events';
    return this.https.get(`${apiURL}`,{ headers: this.headers});
  }
  getCatalogos(idInstitucion: string, catalog: string){
    const apiUrl = `${this.apiUrl}catalogues/${idInstitucion}/${catalog}`
    return this.https.get(`${apiUrl}`, {headers: this.headers})
  }
}
